import { render, staticRenderFns } from "./AuthForms.vue?vue&type=template&id=38e3cd48&scoped=true&"
import script from "./AuthForms.vue?vue&type=script&lang=ts&"
export * from "./AuthForms.vue?vue&type=script&lang=ts&"
import style0 from "./AuthForms.vue?vue&type=style&index=0&id=38e3cd48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e3cd48",
  null
  
)

export default component.exports